var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":_vm.errorType,"title":"Sorry, something is wrong with our server"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.handleBtnBack}},[_vm._v("\n      Tilbake Hjem\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }